import React, { type PropsWithChildren } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { LabelText, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemAllergens = (props: Props) => {
  const { children, withBorder = false } = props;

  const { match } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const separatorStyles = withBorder ? match([styles.separatorXS, undefined]) : undefined;

  const containerStyles = [
    styles.container,
    match([styles.containerXS, styles.containerSM, styles.containerMD, styles.containerLG]),
    separatorStyles,
  ];

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <LabelText bold sizeMatch={['12', '14']} style={styles.title}>
        <FormattedMessage {...messages.title} />
      </LabelText>

      <View style={styles.list}>{children}</View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    flexGrow: 1,
  },
  containerXS: {
    gap: theme.spacing['6'],
    paddingVertical: 36,
  },
  containerSM: {
    gap: theme.spacing['4'],
    paddingLeft: theme.spacing['10'],
  },
  containerMD: {
    gap: theme.spacing['4'],
    paddingLeft: theme.spacing['15'],
  },
  containerLG: {
    gap: theme.spacing['4'],
    paddingLeft: theme.spacing['20'],
  },
  separatorXS: {
    borderColor: theme.colors.LIGHT,
    borderTopWidth: 1,
  },

  list: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing['2'],
  },
  title: {
    color: theme.colors.BROWN,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Allergens',
    description: 'Partner line item | Allergens heading',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  withBorder?: boolean;
}>;
